import { useTranslation } from "react-i18next";
import CustomSharedConfirmationModal from "sipli-fleet-core/components/CustomSharedConfirmationModal/CustomSharedConfirmationModal";

interface ParametersDeleteProps {
  open: boolean;
  isLoading: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}

const ParametersDelete = ({
  open,
  isLoading,
  onCancel,
  onConfirm,
}: ParametersDeleteProps) => {
  const { t } = useTranslation();

  return (
    <CustomSharedConfirmationModal
      open={open}
      title={t("delete_parameter")}
      description={t("delete_parameter_confirmation")}
      confirmText={t("delete")}
      cancelText={t("cancel")}
      isLoading={isLoading}
      onCancel={onCancel}
      onConfirm={onConfirm}
      centered
    />
  );
};

export default ParametersDelete;
